function Contact() {
  return <h1>Contact Component</h1>;
}

export default Contact;
